import { z } from 'zod';

const schemaHeaderFooter = z.object({
    createdAt: z.string(),
    data: z.object({
        _issuer: z.string().optional(),
        mailContent: z.string(),
        mailHTMLContent: z.string(),
    }),
    id: z.string(),
    type: z.enum(['MAIL_HEADER', 'MAIL_FOOTER']),
});

type SchemaHeaderFooter = z.infer<typeof schemaHeaderFooter>;

export { schemaHeaderFooter };
export type { SchemaHeaderFooter };
